import { findMunicipalityByCode } from '@dfl/location';

const MunicipalityStringValue = ({
  provinceCode,
  municipalityCode,
}: {
  provinceCode: string;
  municipalityCode: string;
}) => {
  // TODO: Only  national address??
  return <>{findMunicipalityByCode(`53${provinceCode}${municipalityCode}`)?.name || municipalityCode}</>;
};

export default MunicipalityStringValue;
